import { motion, useReducedMotion } from "framer-motion";

export function AnimatedText({ text, className }: { text: string; className?: string }) {
  const reduceMotion = useReducedMotion();
  const words = text.split(" ");

  return (
    <span className={className} aria-label={text}>
      {words.map((word, index) => (
        <span className="word-mask" aria-hidden="true" key={`${word}-${index}`}>
          <motion.span
            className="word-inner"
            initial={reduceMotion ? { opacity: 0 } : { y: "110%" }}
            animate={reduceMotion ? { opacity: 1 } : { y: 0 }}
            transition={{ duration: reduceMotion ? 0.2 : 0.9, delay: 0.12 + index * 0.08, ease: [0.16, 1, 0.3, 1] }}
          >
            {word}&nbsp;
          </motion.span>
        </span>
      ))}
    </span>
  );
}
